import { useRef, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "context/AuthContext";
import CoverLayout from "layouts/authentication/components/CoverLayout";

export default function SignIn() {
  const { login, error, loading } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [submitting, setSubmitting] = useState(false);
  const lock = useRef(false);
  async function submit(event) {
    event.preventDefault();
    if (lock.current) return;
    lock.current = true;
    setSubmitting(true);
    try {
      await login(email, password);
      navigate("/dashboard");
    } catch {
      /* AuthContext supplies the inline error. */
    } finally {
      lock.current = false;
      setSubmitting(false);
    }
  }
  return (
    <CoverLayout
      title='Welcome back'
      description='Sign in to your Fairsure admin workspace.'
    >
      <form className='finance-form' onSubmit={submit}>
        {error && (
          <div className='notice error' role='alert'>
            {error}
          </div>
        )}
        <label className='fin-field'>
          <span>Email address</span>
          <input
            type='email'
            autoComplete='username'
            required
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder='Enter email address'
          />
        </label>
        <label className='fin-field'>
          <span>Password</span>
          <input
            type={showPassword ? "text" : "password"}
            autoComplete='current-password'
            required
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            placeholder='Enter password'
          />
        </label>
        <div className='toolbar' style={{ justifyContent: "space-between" }}>
          <button
            className='password-toggle'
            type='button'
            onClick={() => setShowPassword((value) => !value)}
          >
            {showPassword ? "Hide" : "Show"} password
          </button>
          {/* <Link
            to="/authentication/forgot-password"
            style={{ color: "#15803d", fontSize: 11 }}
          >
            Forgot password?
          </Link> */}
        </div>
        <button
          className='fin-button'
          disabled={loading || submitting}
          type='submit'
        >
          {loading || submitting ? "Signing in…" : "Sign in"}
        </button>
      </form>
    </CoverLayout>
  );
}
